import MyBankData from './MyBankData'

export default MyBankData
